var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"succesfull-order"},[_c('h3',[_vm._v(_vm._s(_vm._T('Thank you for your order'))+"!")]),_c('h5',[_vm._v(_vm._s(_vm._T('Your packed has been succesfully delivered')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }